/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useEffect, useState} from 'react';
import {Button, DatePicker, Table, TableColumnsType} from "antd";
import dayjs from "dayjs";
import {useMediaQuery} from "react-responsive";
import classNames from "classnames";
import styles from './CashPeriod.module.scss';
import PageTitle from "../../components/common/PageTitle/PageTitle";
import SimplePaging from "../../components/common/paging/SimplePaging";
import cashTxAPI from "../../api/cashTxAPI";
import constants from "../../constants";
import {CashPeriodDataInterface, CashPeriodSumDataInterface, emptyCashPeriodSum} from "./CashPeriod.interface";
import {formatCurrency} from "../../util/format";
import Columns from "./Columns/Columns";
import Summary from "./Summary/Summary";

const { RangePicker } = DatePicker;

const CashPeriod = () => {
	const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
	const today = dayjs().tz('Asia/Seoul').format('YYYY-MM-DD');
	const [fromDate, setFromDate] = useState<string>('');
	const [toDate, setToDate] = useState<string>('');
	const [listData, setListData] = useState<CashPeriodDataInterface[]>([]);
	const [sumData, setSumData] = useState<CashPeriodSumDataInterface>(emptyCashPeriodSum);
	const [firstBaljuData, setFirstBaljuData] = useState<CashPeriodSumDataInterface>(emptyCashPeriodSum);
	const [testUserData, setTestUserData] = useState<CashPeriodSumDataInterface>(emptyCashPeriodSum);
	const [currentPage, setCurrentPage] = useState<number>(1);

	useEffect(() => {
		cashTxAPI.fetchCashPeriodRequestAPI({
			page: currentPage,
			limit: constants.PAGE_SIZE,
			fromDate,
			toDate,
		})
			.then((res) => {
				setListData(res);
			});

		cashTxAPI.fetchCashPeriodSumRequestAPI({ fromDate, toDate })
			.then((res) => {
				setSumData(res);
			});

		cashTxAPI.fetchCashPeriodSumRequestAPI({ fromDate, toDate, reasonCodeList: ['first_balju'] })
			.then((res) => {
				setFirstBaljuData(res);
			});

		cashTxAPI.fetchCashPeriodSumRequestAPI({ fromDate, toDate, reasonCodeList: ['test_user'] })
			.then((res) => {
				setTestUserData(res);
			});
	}, [fromDate, toDate, currentPage]);

	const getValueOfRangePicker: any = () => {
		if (!fromDate || !toDate) return null;
		return [dayjs(fromDate, 'YYYY-MM-DD').tz('Asia/Seoul'), dayjs(toDate, 'YYYY-MM-DD').tz('Asia/Seoul')];
	};

	const onClickClear = () => {
		setFromDate('');
		setToDate('');
		setCurrentPage(1);
	};

	const onClickPrevMonth = () => {
		const prevMonthStartDay = dayjs().tz('Asia/Seoul').subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
		const prevMonthEndDay = dayjs().tz('Asia/Seoul').subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
		setFromDate(prevMonthStartDay);
		setToDate(prevMonthEndDay);
		setCurrentPage(1);
	};

	const onClickThisMonth = () => {
		const thisMonthStartDay = dayjs().tz('Asia/Seoul').startOf('month').format('YYYY-MM-DD');
		setFromDate(thisMonthStartDay);
		setToDate(today);
		setCurrentPage(1);
	};

	const onClickToday = () => {
		setFromDate(today);
		setToDate(today);
		setCurrentPage(1);
	};

	return (
		<div className={styles.outerWrap}>
			<PageTitle title="일별 입출금"/>
			<div className={styles.innerWrap}>
				<div className={classNames(styles.topWrap, { [styles.tabletOrMobile]: isTabletOrMobile })}>
					<RangePicker
						value={getValueOfRangePicker()}
						allowClear={{
							clearIcon: (
								<div
									style={{fontWeight: 'bold'}}
									onClick={onClickClear}
								>
									초기화
								</div>
							)
					}}
						size='large'
						onChange={(date, dateString) => {
							if (!dateString[0] && !dateString[1]) {
								onClickClear();
							} else {
								setCurrentPage(1);
								setFromDate(dateString[0]);
								setToDate(dateString[1]);
							}
						}}
					/>

					<div style={{ display: 'flex', gap: '20px' }}>
						<Button onClick={onClickToday}>오늘</Button>
						<Button onClick={onClickPrevMonth}>지난달</Button>
						<Button onClick={onClickThisMonth}>이번달</Button>
					</div>

					<div className={classNames(styles.summary, { [styles.tabletOrMobile]: isTabletOrMobile })}>
						<div>
							<Summary title="발주지원금" data={firstBaljuData} />
						</div>
						<div>
							<Summary title="테스트" data={testUserData} />
						</div>
						<div>
							<Summary title="기간내" data={sumData} />
						</div>
					</div>
				</div>

				<div className={styles.bottomWrap}>
					<Table
						size="small"
						bordered
						columns={Columns}
						dataSource={listData.map(row => ({ ...row, key: row.updateDate }))}
						pagination={false}
					/>
					<div className={styles.simplePagingWrap}>
						<SimplePaging
							currentPage={currentPage}
							dataLength={listData.length}
							onClickPrePageBtn={() => setCurrentPage((prev) => prev - 1)}
							onClickNextPageBtn={() => setCurrentPage((prev) => prev + 1)}
						/>
					</div>
				</div>

			</div>
		</div>
	);
};

export default CashPeriod;
